import axios from "axios";
import {useEffect, useState} from 'react';
import edit_icon from "../img/icon/pencil-fill.svg"
import {useNavigate} from "react-router-dom";
import config from "../config";
import turnschuhe_icon from "../img/icon/turnschuhe_icon2.png"

const OwnClothesDisplay = ({user, setClickedOwnClothes}) => {
    const [ownClothes, setOwnClothes] = useState(null)
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const getOwnClothes = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}ownerclothes`,{
                headers: {"token": localStorage.getItem("token")},
                params: {userId: user.user_id}
            })
            setOwnClothes(response.data)

        }
        catch (error){
            console.log("Error:",error)
        }
        finally {
            setIsLoading(false);
        }

    }
    useEffect(() => {
        getOwnClothes();
    }, []);

    const handleClick = () =>{
        navigate('/additem/0')
    }

    if (isLoading) {
        return <div className="matches-display"></div>; // Or a Spinner component
    }

    return(
        <div className="matches-display">
            {ownClothes && ownClothes.length > 0 ? ownClothes?.map((match, _index) => (
                <div
                    key={_index}
                    className="own-card"
                    onClick={() => setClickedOwnClothes(match)
                    }
                >
                    <div className="edit">
                        <img onClick={() => navigate("/additem/"+match._id)} src={edit_icon}/>
                    </div>
                    <div class="counter">{match?.interested_users}</div>
                    <div className="img-container">
                        <img src={match?.url} alt={match?.clothing_type + " profile"} />
                    </div>
                </div>
            )):<div className="matches-display"><p>Du hast noch keine Kleider zum Verkaufen gelistet. Füge hier ein Kleidungsstück hinzu:
                  </p><img src={turnschuhe_icon} onClick={handleClick}/></div>}
        </div>
    )
}
export default OwnClothesDisplay
